"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidEmail = isValidEmail;
exports.isValidUrl = isValidUrl;
exports.isValidSalaryRange = isValidSalaryRange;
exports.validateRequiredFields = validateRequiredFields;
exports.sanitizeString = sanitizeString;
exports.sanitizeArray = sanitizeArray;
function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}
function isValidUrl(url) {
    try {
        new URL(url);
        return true;
    }
    catch {
        return false;
    }
}
function isValidSalaryRange(range) {
    return (typeof range.min === 'number' &&
        typeof range.max === 'number' &&
        range.min >= 0 &&
        range.max >= range.min &&
        typeof range.currency === 'string' &&
        range.currency.length === 3);
}
function validateRequiredFields(obj, requiredFields) {
    const missing = requiredFields.filter(field => {
        const value = obj[field];
        if (value === undefined || value === null)
            return true;
        if (typeof value === 'string' && value.trim() === '')
            return true;
        if (Array.isArray(value) && value.length === 0)
            return true;
        return false;
    });
    return {
        valid: missing.length === 0,
        missing
    };
}
function sanitizeString(str) {
    return str.trim().replace(/\s+/g, ' ');
}
function sanitizeArray(arr) {
    return arr
        .map(item => sanitizeString(item))
        .filter(item => item.length > 0);
}
//# sourceMappingURL=validation.js.map